module.exports = __webpack_public_path__ + "static/img/kxdg-red.43e0ee2a.svg";